import React from 'react';
import DynamicTable from '../tables/DynamicTable';

interface IResearchTeamsBoxProps {
    title: string;
    project: any;
}
function ResearchTeamsBox({title, project} : IResearchTeamsBoxProps) {
    return (
        <div className='box'>
            <h2>{title}</h2>
            <div>
            </div>
            <DynamicTable data={project?.knowledgegroups?.models} 
            columns={[
            {id: 1 ,label: "Naam" ,property: "name"},
            {id: 2 ,label: "Bovenliggend", property:'parent.name'},
            ]} />
            <div>
                
            </div>
        </div>
    );
}

export default ResearchTeamsBox;
